import React from 'react';
import FilteredAutomationList from '../components/FilteredAutomationList';

const ListingAgentsOnly = () => {
    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Automation Trigger', href: '/automation' },
        { label: 'Listing Agents Only', active: true }
    ];

    return (
        <FilteredAutomationList
            completionStatus="listing_agents_only"
            title="Listing Agents Only"
            subtitle="Automation runs where only listing agents are present"
            breadcrumbItems={breadcrumbItems}
        />
    );
};

export default ListingAgentsOnly;